import { computed, inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';

export type AppMode = 'nature' | 'garbage';

@Injectable({
  providedIn: 'root',
})
export class AppModeService {
  private readonly STORAGE_KEY = 'faunago_app_mode';
  private router = inject(Router);

  mode = signal<AppMode>(this.loadMode());
  isNature = computed(() => this.mode() === 'nature');
  isGarbage = computed(() => this.mode() === 'garbage');

  toggle() {
    const next: AppMode = this.mode() === 'nature' ? 'garbage' : 'nature';
    this.setMode(next);
    this.navigateAfterToggle(next);
  }

  setMode(mode: AppMode) {
    this.mode.set(mode);
    localStorage.setItem(this.STORAGE_KEY, mode);
  }

  private navigateAfterToggle(next: AppMode) {
    const url = this.router.url.split('?')[0];

    // Map — stay (dashboard reloads via effect)
    if (url === '/map') {
      return;
    }

    // Observations <-> Reports
    if (url.startsWith('/observations')) {
      this.router.navigateByUrl('/garbage');
      return;
    }
    if (url.startsWith('/garbage')) {
      this.router.navigateByUrl('/observations');
      return;
    }

    // Settings/admin — stay
    if (url.startsWith('/admin') || url.startsWith('/profile') || url.startsWith('/settings')) {
      return;
    }

    // Everything else — go to map
    this.router.navigateByUrl('/map');
  }

  private loadMode(): AppMode {
    const stored = localStorage.getItem(this.STORAGE_KEY);
    return stored === 'garbage' ? 'garbage' : 'nature';
  }
}
